export function base64ToBytes(base64: string): Uint8Array {
  const binString = atob(base64);
  return Uint8Array.from(Array.from(binString).map((m) => m.charCodeAt(0)));
}

export function bytesToBase64(bytes: Uint8Array): string {
  const binString = String.fromCodePoint(...bytes);
  return btoa(binString);
}

// 한글 => base64 변환 목적
export function unicodeToBase64(str: string): string {
  return bytesToBase64(new TextEncoder().encode(str));
}

// base64 => 한글 변환 목적
export function base64ToUnicode(str: string): string {
  return new TextDecoder().decode(base64ToBytes(str));
}
